import fileDownload from 'js-file-download'
import request from '../../../data/client/request'

const downloadPdf = (endpoint, fileName) =>
  request.get(endpoint, { responseType: 'arraybuffer' }).then(response => {
    const excel = new Blob([response.data], {
      type: 'application/pdf'
    })

    fileDownload(excel, `${fileName}.pdf`)
  })

export default downloadPdf
